import React, { useEffect, useState } from 'react';
import CONFIG from '../../config'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Common from "./Common";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import mockData from "./mockDataForParagraphStylesForDetail.json"
import "./ParagraphStylesForDetail.css"
import SliderForDetail from "./SliderForDetail";

// 根据知识库的内容转换成前端
function transToView (str, existKeyPool) {
    existKeyPool = existKeyPool === undefined ? [] : existKeyPool;
    if (typeof str === 'string') {
        if(str.startsWith("<")){
           return {
               type: 'html',
               value: str
           }
        } else if (str.indexOf('"class":"picture"') !== -1) {
            let objType;
            try {
                objType = JSON.parse(str);
            } catch (e) {
                str = str.match(/{(\S*)}/ig)[0];
                objType = JSON.parse(str);
            }
            return {
                type: 'picture',
                value: objType.name,
                valueArr: [objType.name],
                ossurl: objType.ossurl,
                tail: objType.tail
            };
        }else if(str.indexOf('"class":"carousel"') !== -1){
            let objType;
            try {
                objType = JSON.parse(str);
            } catch (e) {
                str = str.match(/{(\S*)}/ig)[0];
                objType = JSON.parse(str);
            }
            return {
                type: 'carousel',
                ...objType
            };
        } else if (str.indexOf('"class":"video"') !== -1) {
            let objType;
            try {
                objType = JSON.parse(str);
            } catch (e) {
                str = str.match(/{(\S*)}/ig)[0];
                objType = JSON.parse(str);
            }
            return {
                type: 'video',
                value: objType.name,
                ossurl: objType.ossurl,
                valueArr: [objType.name],
            };
        } else {
            str = Common.keywordsLink(str, existKeyPool);
            return {
                type: 'text',
                value: str,
                valueArr: [str],
            };
        }
    } else {
        if (str[0].indexOf('"class":"picture"') !== -1) {
            const valueArr = str.map(items => {
                return JSON.parse(items).name;
            });
            return {
                type: 'picture',
                value: valueArr[0],
                valueArr,
            };
        } else if (str[0].indexOf('"class":"video"') !== -1) {
            const valueArr = str.map(items => {
                return JSON.parse(items).name;
            });
            return {
                type: 'video',
                value: valueArr[0],
                valueArr,
            };
        } else {
            str = str.map(items => Common.keywordsLink(items, existKeyPool));
            return {
                type: 'text',
                value: str[0],
                valueArr: str,
            };
        }
    }
}

function transToViewAll(contentObj){
    const existKeyPool = [];
    const resArr = [];
    for (const key in contentObj) {
        resArr.push(transToView(contentObj[key], existKeyPool));
    }
    return resArr;
}


const ContentStyles = (props) => {
    const isPc = useMediaQuery(CONFIG.minDeviceWidth)
    return(
        <div>
            <div style={{fontSize: isPc ? 16 : 14, textIndent: isPc ? 32 : 28, fontWeight: 400, lineHeight: 1.4, color: "#333"}}>{props}</div>
        </div>
    )
}

function HTMLComponent({ htmlString }) {
    return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
}


const CommonContentRender = (data) => {
    const isPc = useMediaQuery(CONFIG.minDeviceWidth)
    if(data.length === 0) return
    const content = data[0].content
    const transArr =transToViewAll(content)
    const resArr = []
    transArr.forEach((item, index) => {
        if(item.type == 'text'){
            item.valueArr.map((ite, ind) => {
                resArr.push(<div key={index+'1'+ind} ><p>{ite}</p></div>)
            })
        }else if(item.type == 'html'){
           // resArr.push( <HTMLComponent htmlString={item.value} />)
          let  htmlData=eval("`"+item.value+"`");
            resArr.push(<HTMLComponent htmlString={htmlData} />)
        } else if(item.type == 'picture'){
            const imgArr = []
            if(item.ossurl){
                let ite=item.valueArr[0];
                imgArr.push(
                    <div key={index+'2'+0} style={{display: "flex", justifyContent: "center", flexDirection: "column", alignItems:'center'}}>
                        <div style={{backgroundImage: `url(${item.ossurl})`, width: isPc ? (item.valueArr.length > 1 ? 300 : 450)  : 300, height: isPc ? (item.valueArr.length > 1 ? 220 : 300) : 220, backgroundSize:'contain', backgroundRepeat: "no-repeat", backgroundPosition:"center", cursor:"pointer" }} onClick={() => {window.open(item.ossurl)}}></div>
                        <div style={{textIndent: 0}}><p>{item.tail?item.tail:""}</p></div>
                    </div>
                );
            }else {
                item.valueArr.map((ite, ind) => {
                    imgArr.push(
                        <div key={index+'2'+ind} style={{display: "flex", justifyContent: "center", flexDirection: "column", alignItems:'center'}}>
                            {/*<img src={CONFIG.url(`/img/gallery/${ite}`)} alt="" width={300} height="160vw"/>*/}
                            <div style={{backgroundImage: `url(${CONFIG.url(`/img/gallery/${ite}`)})`, width: isPc ? (item.valueArr.length > 1 ? 300 : 450)  : 300, height: isPc ? (item.valueArr.length > 1 ? 220 : 300) : 220, backgroundSize:'contain', backgroundRepeat: "no-repeat", backgroundPosition:"center", cursor:"pointer" }} onClick={() => {window.open(CONFIG.url(`/img/gallery/${ite}`))}}></div>
                            {/*{isPc ? <div></div>: <div><p>(点击图片查看原图)</p></div>}*/}
                            <div style={{textIndent: 0}}><p>{ite.slice(0, ite.indexOf('.'))}</p></div>
                        </div>
                    );
                })
            }
            resArr.push(<div key={index} style={{display:'flex', flexDirection: isPc ? (imgArr.length > 1 ? "row" : "column") : "column",justifyContent:'space-around',alignItems:'center'}}>{imgArr}</div>)
        }else if(item.type=="carousel"){
            resArr.push(<SliderForDetail {...item} />)
        }
        else if(item.type == 'video') {
            if(item.ossurl){
                item.valueArr.map((ite, ind) => {
                    resArr.push(
                        <div key={index+'3'+ind} style={{display: "flex", justifyContent: "center"}}>
                            <video src={item.ossurl} controls={true} width={isPc ? 500 : 300} ></video>
                        </div>
                    )
                })
            }else {
                item.valueArr.map((ite, ind) => {
                    resArr.push(
                        <div key={index+'3'+ind} style={{display: "flex", justifyContent: "center"}}>
                            <video src={CONFIG.url(`/img/gallery/${ite}`)} controls={true} width={isPc ? 500 : 300} ></video>
                        </div>
                    )
                })
            }
        }
    })
    return resArr
}

const RenderTitle = (data) => {
    const keyWord = "安可迅"
    if(data.length === 0) return
    const name = data[0].name
    if(name.indexOf('®') !== -1) {
        return(
            <h3 style={{display: 'flex'}}><div>{name.split('®')[0]}</div><div><sup>®</sup></div><div>{name.split('®')[name.split('®').length - 1]}</div></h3>
        )
    }else{
        //console.log(name)
        if(name.indexOf(keyWord) !== -1){
            return(<h3 style={{display: 'flex'}}><div>{keyWord}</div><div>{name.split(keyWord)[name.split(keyWord).length - 1]}</div></h3>)
        }else{
            return(<h3>{name}</h3>)
        }
    }
}

//客户服务走马灯图片展示

const RenderServiceCarousel = (album) => {
    let albumArr = []
    if(album.length === 0) return;
    const settings = {
        dots: true,
        dotsClass: "slick-dots slick-thumb",
        infinite: false,
        speed: 500,
        autoplay: false,
        arrows: false
    }
    try {
        albumArr = album[0].val.split(',');
    } catch (error) {
        albumArr = album.split(',')
    }

    return(
        <div style={{paddingBottom: 10}}>
            <Slider {...settings}>
                {albumArr.map((item, index) => (
                    <div key={index}><div style={{backgroundImage: `url(${CONFIG.url(`/img${item}`)})`, backgroundPosition: "center", backgroundSize: "contain", backgroundRepeat: "no-repeat", height:  200, width: "80%", margin: "auto", cursor: "pointer"}} onClick={() =>{window.open(CONFIG.url(`/img${item}`))}}></div></div>
                ))}
            </Slider>
        </div>
    )
}



export default {
    ContentStyles: ContentStyles,
    CommonContentRender: CommonContentRender,
    RenderTitle: RenderTitle,
    RenderServiceCarousel: RenderServiceCarousel
}